'use client'

import { FC } from 'react'
import { Form } from '@repo/ui/form'
import { useAuthForm } from '@/hooks/useAuthForm'
import LoginHeader from './LoginHeader'
import CodeForm from './forms/CodeForm'
import SignInForm from './forms/SignInForm'
import SignUpForm from './forms/SignUpForm'

const LoginForm: FC = () => {
  const {
    authMode,
    isEmailSent,
    userEmail,
    signInForm,
    signUpForm,
    codeForm,
    handleSignInSubmit,
    handleSignUpSubmit,
    handleCodeSubmit,
    handleResend,
    handleGoogleAuthWrapper,
    switchAuthMode,
    handleGoBack,
  } = useAuthForm()

  const renderForm = () => {
    if (!isEmailSent) {
      if (authMode === 'signin') {
        return (
          <Form {...signInForm}>
            <SignInForm
              form={signInForm}
              onEmailSubmit={handleSignInSubmit}
              onGoogleAuth={handleGoogleAuthWrapper}
              onSwitchMode={switchAuthMode}
            />
          </Form>
        )
      } else {
        return (
          <Form {...signUpForm}>
            <SignUpForm
              form={signUpForm}
              onEmailSubmit={handleSignUpSubmit}
              onGoogleAuth={handleGoogleAuthWrapper}
              onSwitchMode={switchAuthMode}
            />
          </Form>
        )
      }
    }

    return (
      <Form {...codeForm}>
        <CodeForm
          form={codeForm}
          email={userEmail}
          onCodeSubmit={handleCodeSubmit}
          onResend={handleResend}
          onBack={handleGoBack}
          authMode={authMode}
        />
      </Form>
    )
  }

  return (
    <div className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="z-[-100] rounded-full absolute w-[95%] right-0 -top-2 aspect-square bg-mint-300 blur-[100px] opacity-[0.1]" />

      <div className="w-fit mx-4 px-4 sm:px-20 pt-9 pb-12 sm:py-11 rounded-2xl flex flex-col justify-center items-center bg-background shadow-[0px_0px_2px_0px_#04774E] shadow-mint-800">
        <LoginHeader variant={isEmailSent ? 'verification' : 'welcome'} />

        <div className="max-w-[360px] w-full">{renderForm()}</div>
      </div>
    </div>
  )
}

export default LoginForm
